import { Check, Palette } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme, THEMES } from "@/theme/ThemeContext";
import { useTranslation } from "@/i18n";

export default function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="h-8 w-8 rounded-full hover:bg-accent flex items-center justify-center text-slate-600 hover:text-slate-900 transition"
          data-testid="theme-switcher-btn"
          aria-label={t("theme.title")}
        >
          <Palette className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52 rounded-2xl">
        <div className="px-2 py-1.5 text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
          {t("theme.title")}
        </div>
        {THEMES.map((th) => (
          <DropdownMenuItem
            key={th.key}
            onClick={() => setTheme(th.key)}
            className="rounded-xl cursor-pointer gap-2"
            data-testid={`theme-option-${th.key}`}
          >
            <span
              className="h-4 w-4 rounded-full ring-1 ring-black/10 shrink-0"
              style={{ backgroundColor: th.dot }}
            />
            <span className="flex-1 text-sm">{t(`theme.names.${th.key}`)}</span>
            {theme === th.key ? <Check className="h-3.5 w-3.5 text-slate-900" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
